export const LOAD_WHITE_LABEL_STYLES_REQUEST = 'la/domain/whiteLabel/LOAD_REQUEST';
export const LOAD_WHITE_LABEL_STYLES_SUCCESS = 'la/domain/whiteLabel/LOAD_SUCCESS';
export const LOAD_WHITE_LABEL_STYLES_FAIL = 'la/domain/whiteLabel/LOAD_FAIL';
